export default function Space({ size = "10px", width = "0px", style }) {
    return (
        <div style={{ ...style, height: size, width: width  }}></div>
    )
}